module.exports = __webpack_public_path__ + "img/banner.38ec9ea4.jpg";